import React, { useState } from 'react';
import {
  Box,
  Button,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Paper,
  Grid,
  IconButton
} from '@mui/material';
import { Close } from '@mui/icons-material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { useNavigate } from 'react-router-dom';
import Navbar from '../Layouts/Navbar';
import BeenhereIcon from '@mui/icons-material/Beenhere';
const dates = [
  '2025-07-11',
  '2025-07-12', 
  '2025-07-13',
  '2025-07-14',
  '2025-07-15',
  '2025-07-16',
  '2025-07-17'
];

export default function AddPreReservation() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    entree: {
      selectedDates: [],
      heure: '',
      trajet: '',
      pointRamassage: '',
      adresse: '40140, Marrakech, Morocco'
    },
    sortie: {
      selectedDates: [],
      heure: '',
      trajet: '',
      pointRamassage: ''
    }
  });

  const handleDateChange = (section, date) => {
    setFormData(prev => ({
      ...prev,
      [section]: {
        ...prev[section],
        selectedDates: prev[section].selectedDates.includes(date)
          ? prev[section].selectedDates.filter(d => d !== date)
          : [...prev[section].selectedDates, date]
      }
    }));
  };

  const handleInputChange = (section, field, value) => {
    setFormData(prev => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value
      }
    }));
  };

  const handleSave = () => {
    console.log('Saving pre-reservation:', formData);
    // Add your save logic here
    navigate('/pre-reservation');
  };

  const handleCancel = () => {
    navigate('/pre-reservation');
  };

  return (
    <Box>
      <Navbar />
      <Box p={3}>
        {/* Header */}
          <Box display="flex" alignItems="center" sx={{ cursor: 'pointer' }}>
            <CalendarMonthIcon />
            <Typography variant="h6">NOUVELLE PRÉ-RÉSERVATION</Typography>
          </Box>

        <Grid container spacing={3}>
          {/* ENTREE Section */}
          <Grid item xs={12} md={6}>
            <Paper sx={{ p: 3, height: 'fit-content' }}>
              <Box
                sx={{
                  bgcolor: 'red',
                  color: 'white',
                  p: 1,
                  mb: 3,
                  textAlign: 'center',
                  fontWeight: 'bold',
                  fontSize: '18px'
                }}
              >
                ENTREE
              </Box>

              {/* Dates Selection */}
              <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'bold' }}>
                Dates nécessitant le transport en entrée *
              </Typography>
              <Box sx={{ mb: 3 }}>
                {dates.map(date => (
                  <FormControlLabel
                    key={date}
                    control={
                      <Checkbox
                        checked={formData.entree.selectedDates.includes(date)}
                        onChange={() => handleDateChange('entree', date)}
                        sx={{
                          color: 'red',
                          '&.Mui-checked': { color: 'red' }
                        }}
                      />
                    }
                    label={date}
                    sx={{ display: 'block', mb: 1 }}
                  />
                ))}
              </Box>

              {/* Time Input */}
            <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold' }}>
            Heure d'entrée
            </Typography>
            <FormControl fullWidth size="small" sx={{ mb: 3 }}>
            <Select
                value={formData.entree.heure}
                onChange={(e) => handleInputChange('entree', 'heure', e.target.value)}
                sx={{
                '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': { borderColor: '#000' },
                    '&.Mui-focused fieldset': { borderColor: 'red' }
                }
                }}
            >
                {Array.from({ length: 7 }, (_, index) => {
                const time = new Date(0, 0, 0, 6 + index, 0, 0); // Time starts at 06:00
                const timeString = time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
                return <MenuItem key={timeString} value={timeString}>{timeString}</MenuItem>;
                })}
            </Select>
            </FormControl>

              {/* Route Selection */}
              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold' }}>
                Trajet
              </Typography>
              <FormControl fullWidth size="small" sx={{ mb: 3 }}>
                <Select
                  value={formData.entree.trajet}
                  onChange={(e) => handleInputChange('entree', 'trajet', e.target.value)}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '&:hover fieldset': { borderColor: '#000' },
                      '&.Mui-focused fieldset': { borderColor: 'red' }
                    }
                  }}
                >
                  <MenuItem value="">Sélectionner un trajet</MenuItem>
                  <MenuItem value="trajet1">Trajet 1</MenuItem>
                  <MenuItem value="trajet2">Trajet 2</MenuItem>
                </Select>
              </FormControl>

              {/* Pickup Point */}
              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold' }}>
                Nom du trajet
              </Typography>
              <FormControl fullWidth size="small" sx={{ mb: 3 }}>
                <Select
                  value={formData.entree.pointRamassage}
                  onChange={(e) => handleInputChange('entree', 'pointRamassage', e.target.value)}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '&:hover fieldset': { borderColor: '#000' },
                      '&.Mui-focused fieldset': { borderColor: 'red' }
                    }
                  }}
                >
                  <MenuItem value="">Sélectionner un point</MenuItem>
                  <MenuItem value="point1">Point 1</MenuItem>
                  <MenuItem value="point2">Point 2</MenuItem>
                </Select>
              </FormControl>

              {/* Address */}
              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold' }}>
                Point de ramassage
              </Typography>
              <FormControl fullWidth size="small" sx={{ mb: 3 }}>
                <Select
                  value={formData.entree.pointRamassage}
                  onChange={(e) => handleInputChange('entree', 'pointRamassage', e.target.value)}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '&:hover fieldset': { borderColor: '#000' },
                      '&.Mui-focused fieldset': { borderColor: 'red' }
                    }
                  }}
                >
                  <MenuItem value="">Sélectionner un point de ramassage</MenuItem>
                  <MenuItem value="ramassage1">Point de ramassage 1</MenuItem>
                  <MenuItem value="ramassage2">Point de ramassage 2</MenuItem>
                </Select>
              </FormControl>

              {/* Address Field */}
              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold' }}>
                Adresse du domicile
              </Typography>
              <TextField
                fullWidth
                size="small"
                value={formData.entree.adresse}
                onChange={(e) => handleInputChange('entree', 'adresse', e.target.value)}
                sx={{
                  mb: 2,
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': { borderColor: '#000' },
                    '&.Mui-focused fieldset': { borderColor: 'red' }
                  }
                }}
              />
              <Typography variant="caption" color="text.secondary">
                Votre adresse est modifiable depuis le menu "Mon compte"
              </Typography>

              {/* Closest Pickup Point */}
              <Typography variant="subtitle1" sx={{ mb: 1, mt: 2, fontWeight: 'bold' }}>
                Point de repère le plus proche
              </Typography>
              <TextField
                fullWidth
                size="small"
                placeholder="Entrez le point de repère le plus proche"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': { borderColor: '#000' },
                    '&.Mui-focused fieldset': { borderColor: 'red' }
                  }
                }}
              />
            </Paper>
          </Grid>

          {/* SORTIE Section */}
          <Grid item xs={12} md={6}>
            <Paper sx={{ p: 3, height: 'fit-content' }}>
              <Box
                sx={{
                  bgcolor: 'red',
                  color: 'white',
                  p: 1,
                  mb: 3,
                  textAlign: 'center',
                  fontWeight: 'bold',
                  fontSize: '18px'
                }}
              >
                SORTIE
              </Box>

              {/* Dates Selection */}
              <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'bold' }}>
                Dates nécessitant le transport en sortie *
              </Typography>
              <Box sx={{ mb: 3 }}>
                {dates.map(date => (
                  <FormControlLabel
                    key={date}
                    control={
                      <Checkbox
                        checked={formData.sortie.selectedDates.includes(date)}
                        onChange={() => handleDateChange('sortie', date)}
                        sx={{
                          color: 'red',
                          '&.Mui-checked': { color: 'red' }
                        }}
                      />
                    }
                    label={date}
                    sx={{ display: 'block', mb: 1 }}
                  />
                ))}
              </Box>

              {/* Time Input */}
                <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold' }}>
                Heure de sortie
                </Typography>
                <FormControl fullWidth size="small" sx={{ mb: 3 }}>
                <Select
                    value={formData.sortie.heure}
                    onChange={(e) => handleInputChange('sortie', 'heure', e.target.value)}
                    sx={{
                    '& .MuiOutlinedInput-root': {
                        '&:hover fieldset': { borderColor: '#000' },
                        '&.Mui-focused fieldset': { borderColor: 'red' }
                    }
                    }}
                >
                    {Array.from({ length: 5 }, (_, index) => {
                    const time = new Date(0, 0, 0, 19 + index, 0, 0); // Time starts at 19:00
                    const timeString = time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
                    return <MenuItem key={timeString} value={timeString}>{timeString}</MenuItem>;
                    })}
                </Select>
                </FormControl>

              {/* Route Selection */}
              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold' }}>
                Trajet
              </Typography>
              <FormControl fullWidth size="small" sx={{ mb: 3 }}>
                <Select
                  value={formData.sortie.trajet}
                  onChange={(e) => handleInputChange('sortie', 'trajet', e.target.value)}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '&:hover fieldset': { borderColor: '#000' },
                      '&.Mui-focused fieldset': { borderColor: 'red' }
                    }
                  }}
                >
                  <MenuItem value="">Sélectionner un trajet</MenuItem>
                  <MenuItem value="trajet1">Trajet 1</MenuItem>
                  <MenuItem value="trajet2">Trajet 2</MenuItem>
                </Select>
              </FormControl>

              {/* Pickup Point */}
              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold' }}>
                Nom du trajet
              </Typography>
              <FormControl fullWidth size="small" sx={{ mb: 3 }}>
                <Select
                  value={formData.sortie.pointRamassage}
                  onChange={(e) => handleInputChange('sortie', 'pointRamassage', e.target.value)}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '&:hover fieldset': { borderColor: '#000' },
                      '&.Mui-focused fieldset': { borderColor: 'red' }
                    }
                  }}
                >
                  <MenuItem value="">Sélectionner un point</MenuItem>
                  <MenuItem value="point1">Point 1</MenuItem>
                  <MenuItem value="point2">Point 2</MenuItem>
                </Select>
              </FormControl>

              {/* Point de ramassage */}
              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold' }}>
                Point de ramassage
              </Typography>
              <FormControl fullWidth size="small">
                <Select
                  value={formData.sortie.pointRamassage}
                  onChange={(e) => handleInputChange('sortie', 'pointRamassage', e.target.value)}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '&:hover fieldset': { borderColor: '#000' },
                      '&.Mui-focused fieldset': { borderColor: 'red' }
                    }
                  }}
                >
                  <MenuItem value="">Sélectionner un point de ramassage</MenuItem>
                  <MenuItem value="ramassage1">Point de ramassage 1</MenuItem>
                  <MenuItem value="ramassage2">Point de ramassage 2</MenuItem>
                </Select>
              </FormControl>
            </Paper>
          </Grid>
        </Grid>

        {/* Action Buttons */}
        <Box display="flex" justifyContent="start" gap={2} mt={4}>
          <Button
            variant="outlined"
            onClick={handleCancel}
            sx={{
              color: 'red',
              borderColor: 'red',
              textTransform: 'none',
              px: 4,
              '&:hover': {
                backgroundColor: 'red',
                color: 'white'
              }
            }}
          >
            ✕ Annuler
          </Button>
          <Button
            variant="outlined"
            onClick={handleSave}
            sx={{
              color: 'red',
              borderColor: 'red',
              textTransform: 'none',
              px: 4,
              '&:hover': {
                backgroundColor: 'red',
                color: 'white'
              }
            }}
            startIcon={<BeenhereIcon/>}
          >
            Enregistrer
          </Button>
        </Box>
      </Box>
    </Box>
  );
}